import { get } from 'vuex-pathify';

export default {
  computed: {
    isBasicToolsEnabled: get('admin/additionalModules@BASIC_TOOLS_MODULE.enabled'),
    hasCopyPermissions() {
      return this.isBasicToolsEnabled && this.$store.get('users/toolsPermissions')['BASIC_TOOLS_MODULE'].main_value > 0;
    },
    isCopy1Enabled: get('admin/settingsValues@basic_tools_v1_enabled'),
    isCopy1ButtonVisible() {
      return this.hasCopyPermissions && this.isCopy1Enabled && this.isGeometricalLayer && !this.geometryReadOnly;
    },
    copy1Button() {
      return this.isCopy1ButtonVisible
        ? [
            {
              name: 'copy1',
              icon: 'mdi-content-copy',
              disabled: !this.isAtLeastOneObjectSelected,
              tooltip: this.getButtonTooltip({
                condition: this.isAtLeastOneObjectSelected,
                enableTooltip: 'sidebar.copyObjectsGeometry.title',
                disableTooltip: 'button.toCopyObjectGeoemtry',
                requirement: 'button.atLeastOneSelected',
              }),
              fontSize: '19px',
            },
          ]
        : [];
    },

    isCopy2Enabled: get('admin/settingsValues@basic_tools_v2_enabled'),
    isCopy2ButtonVisible() {
      return this.hasCopyPermissions && this.isCopy2Enabled && this.layerScope === 'core'; //geometryczne?
    },
    copy2Button() {
      return this.isCopy2ButtonVisible
        ? [
            {
              name: 'copy2',
              icon: 'mdi-content-copy',
              disabled: !this.isAtLeastOneObjectSelected,
              tooltip: this.getButtonTooltip({
                condition: this.isAtLeastOneObjectSelected,
                enableTooltip: 'sidebar.copyObjects.title',
                disableTooltip: 'button.toCopyObject',
                requirement: 'button.atLeastOneSelected',
              }),
              fontSize: '19px',
            },
          ]
        : [];
    },
  },
  data: () => ({
    isCopy1Loaded: false,
    isCopy1Visible: false,
    isCopy1Loading: false,

    isCopy1ErrorsLoaded: false,
    isCopy1ErrorsVisible: false,
    copy1Errors: [],

    isCopy2Loaded: false,
    isCopy2Visible: false,
    isCopy2Loading: false,
  }),
  methods: {
    toggleCopy1() {
      this.isCopy1Loaded = true;
      this.isCopy1Visible = true;
    },
    toggleCopy2() {
      this.isCopy2Loaded = true;
      this.isCopy2Visible = true;
    },
    onTopoCopy1Errors(errors) {
      this.copy1Errors = errors;
      this.isCopy1Loading = false;
      this.isCopy1Visible = false;
      this.isCopy1ErrorsLoaded = true;
      this.isCopy1ErrorsVisible = true;
    },
  },
};
